import { Assessment } from '$synapse/models';
import { inject, Injectable } from '@angular/core';
import { concatMap, filter, Observable, take, timer } from 'rxjs';
import { InterviewService } from './interview.service';
import {
  AssessmentPollingOptions,
  ResolvedAssessmentPollingOptions,
} from '../models/assessment-polling-options';

@Injectable({
  providedIn: 'root',
})
export class AssessmentInterviewPollingService {
  private static readonly DEFAULT_OPTIONS: ResolvedAssessmentPollingOptions = {
    initialDelayMs: 5_000,
    intervalMs: 2_000,
  };

  private readonly _interviewService = inject(InterviewService);

  pollAssessmentUntilReady(
    assessmentId: string,
    options: AssessmentPollingOptions = {}
  ): Observable<Assessment> {
    return this.createPollingStream(assessmentId, this.resolveOptions(options));
  }

  private resolveOptions(
    options: AssessmentPollingOptions
  ): ResolvedAssessmentPollingOptions {
    return {
      initialDelayMs:
        options.initialDelayMs ??
        AssessmentInterviewPollingService.DEFAULT_OPTIONS.initialDelayMs,
      intervalMs:
        options.intervalMs ??
        AssessmentInterviewPollingService.DEFAULT_OPTIONS.intervalMs,
    };
  }

  private createPollingStream(
    assessmentId: string,
    options: ResolvedAssessmentPollingOptions
  ): Observable<Assessment> {
    return timer(options.initialDelayMs, options.intervalMs).pipe(
      concatMap(() => this._interviewService.getAssessmentById(assessmentId)),
      filter((assessment) => this.isAssessmentPending(assessment)),
      take(1)
    );
  }

  private isAssessmentPending(assessment: Assessment): boolean {
    return assessment.status !== 'PENDING';
  }
}
